export default {
  features: {
    uploadApplicationContract: {
      title: 'Shartnoma fayli',
      file: 'Shartnoma fayli',
      common: 'Fayl',
    },
  },
};
